
import InitRequestPayload from "slotworks/model/gameplay/requests/init-request-payload";
import CommsManager from "slotworks/server/comms-manager";

export function InitCommand() {
    return CommsManager.request(new InitRequestPayload());
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/comms/init-command.ts